/* eslint-disable camelcase */
import {ApiError} from "@connox/typescript-library";

interface IPayPalOptions {
  pp_nonce: string;
}

interface IOrderReference {
  getAmazonOrderReferenceId: () => string;
  getAmazonContractId: () => string;
}

export interface IAmazonError {
  getErrorCode: () => string;
  getErrorMessage: () => string;
}

interface IWidgetOptions {
  amazonOrderReferenceId: string;
  design: {designMode: "responsive" | "smartphoneCollapsible"};
  displayMode: "Edit" | "Read";
  onError: (err: IAmazonError) => void;
  onOrderReferenceCreate?: (orderReference: IOrderReference) => void;
  sellerId: string;
}

interface IConfirmationFlow {
  error: () => void;
  success: () => void;
}

interface IWalletReturnFunction {
  setPresentmentCurrency: (activeCurrency: string) => () => void;
}

interface IAmazonPayOptions {
  accessToken: string;
  amazon: {
    Login: {
      authorize: (
        options: {popup: boolean; scope: string},
        next: (response: {access_token: string; error: string; error_description: string}) => void,
      ) => void;
      logout: () => void;
      retrieveProfile: (
        accessToken: string,
        cb: (response: {profile: {PrimaryEmail: string}; error: string}) => void,
      ) => void;
      setClientId: (clientId: string) => void;
      setUseCookie: (useCookie: boolean) => void;
    };
  };
  amazonPayAuthorized: boolean;
  isBillingAgreementAddressSet: boolean;
  isBillingAgreementPaymentSet: boolean;
  OffAmazonPayments: {
    Button: (
      containerId: string,
      merchantId: string,
      loginOptions: {
        authorization: () => void;
        color: "Gold" | "LightGray" | "DarkGray";
        language: string;
        onError: (err: ApiError & {getErrorCode: () => string; getErrorMessage: () => string}) => void;
        onSignIn: (orderReference: IOrderReference) => void;
        size: "small" | "medium" | "large" | "x-large";
        type: "PwA" | "Pay" | "A" | "LwA" | "Login";
      },
    ) => void;
    Widgets: {
      AddressBook: new (
        AddressBookOptions: IWidgetOptions & {
          onAddressSelect?: () => Promise<void>;
        },
      ) => () => void;
      Wallet: new (
        WalletOptions: IWidgetOptions & {
          onPaymentSelect?: () => void;
        },
      ) => IWalletReturnFunction;
    };
    initConfirmationFlow: (
      merchantId: string,
      orderReferenceId: string,
      callback: (confirmationFlow: IConfirmationFlow) => Promise<void>,
    ) => void;
  };
  onAmazonLoginReady: () => void;
  onAmazonPaymentsReady: () => void;
  orderReferenceId: string;
  paymentTransactionId: string;
  annotationTextArea?: string;
  confirmationFlow: IConfirmationFlow;
  isIntoPreauthorizing: boolean;
  isPreauthorizingDone: boolean;
  c_ActiveCurrency: string;
  c_ActiveCountry: string;
  c_PromotionId?: string;
  c_PromotionContentReference?: string;
  isIntoChangingCountry: boolean;
  isIntoSettingPhoneNoInShippingStep: boolean;
}

interface Connex {
  projectMayhem: boolean;
  c_links: {
    URL_Privacy: string;
    URL_TermsAndConditions: string;
    URL_RevocationRights: string;
    URL_Imprint: string;
    ContactPhone: string;
  };

  Cookiebot?: {
    hasResponse: boolean;
    consent: {
      marketing: boolean;
    };
  };
}

declare const window: Window & IAmazonPayOptions & IPayPalOptions & Connex;

export default window;
